import { useCallback } from 'react';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import {
	fireOperationalAnalytics,
	useAnalyticsEvents,
} from '@atlassian/jira-product-analytics-bridge';

const useIssueRankService = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const rankToTopQuery = useCallback(
		async (issueId: number, onSuccess: () => void, onFailure: () => void): Promise<void> => {
			try {
				await performPostRequest('/rest/greenhopper/1.0/rank/global/first', {
					body: JSON.stringify({
						issueId,
					}),
				});
				fireOperationalAnalytics(
					createAnalyticsEvent({
						type: 'sendOperationalEvent',
						action: 'success',
						actionSubject: 'rankToTopQuery',
					}),
					'rankToTopQuery success',
				);
				onSuccess();
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (e: any) {
				fireErrorAnalytics({
					error: e,
					meta: {
						id: 'rankToTopQuery',
						packageName: 'jiraIssueNavigatorIssueOperationsServices',
						teamName: 'empanada',
					},
				});
				onFailure();
			}
		},
		[createAnalyticsEvent],
	);

	const rankToBottomQuery = useCallback(
		async (issueId: number, onSuccess: () => void, onFailure: () => void): Promise<void> => {
			try {
				await performPostRequest('/rest/greenhopper/1.0/rank/global/last', {
					body: JSON.stringify({
						issueId,
					}),
				});
				fireOperationalAnalytics(
					createAnalyticsEvent({
						type: 'sendOperationalEvent',
						action: 'success',
						actionSubject: 'rankToBottomQuery',
					}),
					'rankToBottomQuery success',
				);
				onSuccess();
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (e: any) {
				fireErrorAnalytics({
					error: e,
					meta: {
						id: 'rankToBottomQuery',
						packageName: 'jiraIssueNavigatorIssueOperationsServices',
						teamName: 'empanada',
					},
				});
				onFailure();
			}
		},
		[createAnalyticsEvent],
	);

	return {
		rankToTopQuery,
		rankToBottomQuery,
	};
};

export default useIssueRankService;
